// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editModeBg {
  background-color: white;
}

.editModeBg:hover {
  background-color: #fafbfc;
}

.timeline-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  padding-left: 16px;
  padding-top: 6px;
}

.stage {
  height: 4px;
  background: #0acbbc;
  margin: 0 2px;
  border-radius: 3px;
  position: relative;
  min-width: 10px;
}
.offSeasonStage {
  height: 6px;
  background: #d0d3d9;
  margin: 0 2px;
  border-radius: 3px;
  position: relative;
  min-width: 10px;
}

.stage-label {
  position: absolute;
  top: -30px;
  font-size: 12px;
  color: #789;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.stage-icon {
  margin-left: 4px;
  margin-bottom: 2px;
  flex-shrink: 0;
}
.now-indicator {
  position: absolute;
  top: 32px;
}

.now-marker {
  width: 2px;
  border-radius: 2px;
  height: 12px;
  background: #e55565;
  position: absolute;
  left: 50%;
}

.now-label {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 14px;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  border-radius: 4px;
  padding: 2px 6px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  font-size: 12px;
  height: 24px;
  width: 40px;
  border: 1px solid #dce0e8;
}

.tooltipBody {
  background-color: #4d5674;
  color: white;
  padding: 8px 12px;
  line-height: 16px;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  font-size: 12px;
  z-index: 10;
  pointer-events: none;
}

.tooltipFooter {
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #4d5674;
}

.footerButton {
  width: 76px;
  height: 24px;
}

.border-alert {
  border: 1px solid #f66b7a !important;
}
`, "",{"version":3,"sources":["webpack://./app/styles/phases.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;EACtC,eAAe;EACf,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":[".editModeBg {\n  background-color: white;\n}\n\n.editModeBg:hover {\n  background-color: #fafbfc;\n}\n\n.timeline-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  width: 100%;\n  padding-left: 16px;\n  padding-top: 6px;\n}\n\n.stage {\n  height: 4px;\n  background: #0acbbc;\n  margin: 0 2px;\n  border-radius: 3px;\n  position: relative;\n  min-width: 10px;\n}\n.offSeasonStage {\n  height: 6px;\n  background: #d0d3d9;\n  margin: 0 2px;\n  border-radius: 3px;\n  position: relative;\n  min-width: 10px;\n}\n\n.stage-label {\n  position: absolute;\n  top: -30px;\n  font-size: 12px;\n  color: #789;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n\n.stage-icon {\n  margin-left: 4px;\n  margin-bottom: 2px;\n  flex-shrink: 0;\n}\n.now-indicator {\n  position: absolute;\n  top: 32px;\n}\n\n.now-marker {\n  width: 2px;\n  border-radius: 2px;\n  height: 12px;\n  background: #e55565;\n  position: absolute;\n  left: 50%;\n}\n\n.now-label {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 14px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: white;\n  border-radius: 4px;\n  padding: 2px 6px;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);\n  font-size: 12px;\n  height: 24px;\n  width: 40px;\n  border: 1px solid #dce0e8;\n}\n\n.tooltipBody {\n  background-color: #4d5674;\n  color: white;\n  padding: 8px 12px;\n  line-height: 16px;\n  border-radius: 6px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n  font-size: 12px;\n  z-index: 10;\n  pointer-events: none;\n}\n\n.tooltipFooter {\n  position: absolute;\n  bottom: -6px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-top: 6px solid #4d5674;\n}\n\n.footerButton {\n  width: 76px;\n  height: 24px;\n}\n\n.border-alert {\n  border: 1px solid #f66b7a !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
